const initialState = {
  apiResponse: null,
  appnData: null,
  selectedAppn: "",
};

const appointmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_APPOINTMENT_DETAILS":
      const completeData = action?.payload?.data;
      const apiResponse = JSON.stringify(action?.payload?.data);
      return {
        ...state,
        appnData: completeData,
        apiResponse: apiResponse,
      };
    case "SET_CURRENT_APPOINTMENT_UUID":
      const uuid = action?.payload?.data;
      return {
        ...state,
        selectedAppn: uuid,
      };
    default:
      return state;
  }
};

export default appointmentReducer;
